<template>
  <div id="docx-demo">
      <Document />
  </div>
</template>

<script setup>
import Document from '@/components/Document.vue'

</script>

<style scoped>
#docx-demo {
  width: 100%;
  height: 100%;
}
</style>